<template>
    <ValidationErrors :show="showErrors"/>
    <Head :title="'Expenses - ' + project.title"/>
    <Audit v-if="openModal" @close="openModal = false" :open="openModal" :activity_logs="currentExpense.activity_logs" />
    <div class="w-full mb-6">
        <ProjectHeader :project="project"></ProjectHeader>
        <div class="space-y-6 lg:col-span-9">
            <section aria-labelledby="payment-details-heading">
                <form @submit.prevent="submit">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="bg-white px-4 p-6 space-y-6">
                            <div class="flex pb-5 border-b border-gray-200 justify-between items-center">
                                <h3 class="text-lg leading-6 font-bold text-gray-900">Expenses</h3>
                                <div class="flex text-right items-end">
                                    <Button @click="emitter.emit('openExpenseSlideout', project)"
                                            class="shadow-md inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg"
                                             fill="none"
                                             viewBox="0 0 24 24"
                                             stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                  stroke-width="2"
                                                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                        </svg>
                                        Create New Expense
                                    </Button>

                                </div>
                            </div>

                            <div class="flex flex-col mt-3 space-y-3">
                                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                            <table class="min-w-full divide-y divide-gray-200">
                                                <thead class="bg-gray-50">
                                                <tr>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Description
                                                    </th>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Employee Name
                                                    </th>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Payment Date
                                                    </th>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Amount
                                                    </th>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Expense Type
                                                    </th>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Transaction Type
                                                    </th>
                                                    <th scope="col"
                                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                                        Quote
                                                    </th>

                                                    <th scope="col" class="relative px-6 py-3">
                                                        <span class="sr-only">Edit</span>
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-if="expenses.data.length > 0"
                                                    v-for="(expense, index) in expenses.data" :key="index"
                                                    :class="{'bg-gray-100': index % 2}"
                                                    class="hover:bg-gray-50 cursor-pointer items-center">
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900" v-html="expense.description">
                                                    </td>
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {{ expense.user?.name ?? 'Deleted user' }}
                                                    </td>
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                      {{ moment(expense.paid_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
                                                    </td>
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {{ formatCurrency(expense.amount, project.bank_account.currency.code, true) }}
                                                    </td>
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {{ expense.expense_type.name }}
                                                    </td>
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {{ expense.transaction_type.name }} <br/>
                                                        <span class="w-full text-gray-400">{{ expense.transaction_type.title }}</span>
                                                    </td>
                                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                                        {{ expense.quote.name }} <br/>
                                                    </td>

                                                    <td class="my-auto pl-6 py-4 whitespace-nowrap text-right text-sm flex">
                                                        <PencilAltIcon @click="emitter.emit('editExpenseSlideout', expense)"
                                                                       class="my-auto w-6 h-6 mr-3"></PencilAltIcon>
                                                        <TrashIcon @click="deleteExpense(expense.id)"
                                                                   class="my-auto w-6 h-6 text-red-500"></TrashIcon>
                                                        <button type="button" @click="currentExpense = expense, openModal = true"
                                                            class="inline-flex ml-3 items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 rounded-md text-white bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black">
                                                            Show Changelog
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr v-else>
                                                    <td colspan="9"
                                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 bg-gray-100">
                                                        There are no expenses available for your search criteria.
                                                    </td>
                                                </tr>
                                                <tr class="bg-gray-200">
                                                    <td colspan="3"
                                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 bg-gray-100 font-bold">
                                                        TOTALS
                                                    </td>
                                                    <td colspan="5"
                                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 bg-gray-100">
                                                        {{ formatCurrency(collect(expenses.data).sum('amount'), project.bank_account.currency.code, true) }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <Pagination :links="expenses.links"/>
                            </div>

                            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                    <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </section>
        </div>
    </div>
</template>


<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head} from "@inertiajs/vue3";
import {
    ClipboardCopyIcon,
    PlusSmIcon,
    UsersIcon,
    InformationCircleIcon,
    ChevronDownIcon,
    CogIcon,
    PencilAltIcon,
    CheckCircleIcon,
    TrashIcon
} from "@heroicons/vue/outline"
import ValidationErrors from "@/Components/ValidationErrors";
import ProjectHeader from "@/Components/ProjectHeader";
import CreateQuote from "@/Components/SlideOuts/CreateQuote";
import {Popover, PopoverButton, PopoverGroup} from "@headlessui/vue";
import Button from "@/Components/Button.vue";

import DuplicateQuote from "@/Components/SlideOuts/DuplicateQuote";
import Pagination from "@/Components/Pagination.vue";
import CreateExpense from "@/Components/SlideOuts/CreateExpense.vue";
import moment from "moment";
import {emitter} from "@/eventHub";
import collect from 'collect.js';
import Audit from "@/Components/Modal/Audit.vue";
import { ref } from "vue";

export default {
    layout: Authenticated,
    components: {
        CreateExpense,
        DuplicateQuote,
        Button,
        CreateQuote,
        ProjectHeader,
        ValidationErrors,
        Link,
        Head,
        PlusSmIcon,
        UsersIcon,
        InformationCircleIcon,
        Popover,
        PopoverButton,
        ChevronDownIcon,
        PopoverGroup,
        CogIcon,
        PencilAltIcon,
        ClipboardCopyIcon,
        CheckCircleIcon,
        Pagination,
        TrashIcon,
        Audit
    },
    props: {
        project: Object,
        expenses: Object,
        expenses_count: Number
    },
    setup(){
        const openModal = ref(false);
        const currentExpense = ref(null);

        return {openModal, currentExpense};
    },
    data() {
        return {
            showErrors: false,
            emitter: emitter
        }
    },
    created() {
        this.moment = moment
    },
    methods: {
        collect,
        deleteExpense(id) {
            this.$swal.fire({
                title: 'Remove Expense',
                html: "You are removing an expense. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        // Delete the country
                        this.$inertia.delete(route('frontend.expenses.expense.delete', id), {
                            preserveScroll: true
                        });
                    }
                });
        },
    }
}
</script>
